import {useEffect, useState} from 'react';
import ApiDatabase from 'server'
import UseContext from "hooks/useContext";

const Usefetchdata = () => {
    const {refreshUser, refreshWorker,setTempData} = UseContext()
    const [userData, setUserData] = useState([])
    const [tempWorkerData, setTempWorkerData] = useState([])

    useEffect(() => {

        ApiDatabase.getUserProfile({},
            (data => {
                setUserData(data)

            }),
            (err =>
            {
                localStorage.removeItem('xsrfToken')
                localStorage.removeItem('rUser')
                window.location.href=process.env.REACT_APP_INTERIM_LOGIN
            }))

    }, [refreshUser])

    useEffect(() => {
        ApiDatabase.getTempWorker({},
            (data => {
                setTempWorkerData(data)
                setTempData(data)
            }),
            (err => console.error(err)))
    }, [refreshWorker])
    return {
        userData, tempWorkerData
    }

}

export default Usefetchdata;